'use client'
import EditIcon from '@/app/icons/edit'
import UserContext from '@/context/user-context'
import { cn } from '@/util/cn'
import useClientRender from '@/util/use-client-render'
import { usePathname } from 'next/navigation'
import { useContext, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { clearBulkEdit, setBulkEditOpen, useBulkEditOpen } from './bulk-edit-state'
import useStickyFooterOffset from './use-sticky-footer-offset'

const OpenButton = () => {
    const pathname = usePathname()
    const isCurationPage = pathname === '/edit/gifs' || pathname === '/edit/gifs/'
    const stickyFooterOffset = useStickyFooterOffset()
    return (
        <div
            className={cn('fixed bottom-5 hidden md:block', isCurationPage ? 'right-5' : 'left-5')}
            style={{ bottom: `calc(1.25rem + ${stickyFooterOffset}px)` }}
        >
            <div
                className="flex cursor-pointer items-center justify-center border-2 border-solid border-giphyGreen bg-giphyDarkestGrey  p-3"
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setBulkEditOpen(true)
                }}
            >
                <EditIcon className="size-4 fill-giphyWhite" />
            </div>
        </div>
    )
}

const BulkEditButton = () => {
    const isEnabled = useBulkEditOpen()
    const { user } = useContext(UserContext)
    const isClient = useClientRender()
    useEffect(() => {
        return () => clearBulkEdit()
    }, [])
    return isClient && user?.permissions?.bulk_edit
        ? createPortal(isEnabled ? null : <OpenButton />, document.body)
        : null
}

export default BulkEditButton
